<template>
  <v-btn
    text small height="32" class="action-btn elevation-0 rounded-lg"
    @click="$router.back()"
  >
    <v-icon class="uikit-icon chevron-left size-20" />
    <span class="ml-1 btn-text">Назад</span>
  </v-btn>
</template>

<script>
export default { name: 'ButtonGoBack' }
</script>
